<template>
    <div class="goose" :class="currentStates">
        <div class="bg-mask" id="mask"></div>
        <div class="light-box" id="lightBox">
            <div class="light-1"></div>
            <div class="light-2"></div>
            <div class="light-3"></div>
            <div class="light-4"></div>
            <div class="anim-eggs" ref="animEgg">
                <div class="egg-1" id="egg1"></div>
                <div class="egg-2" id="egg2"></div>
                <div class="egg-3" id="egg3"></div>
                <div class="egg-4" id="egg4"></div>
                <div class="egg-5" id="egg5"></div>
                <div class="egg-6" id="egg6"></div>
            </div>
        </div>
        <div class="flower-box" v-show="flowerPlay" ref="flowerBox">

        </div>
        <div class="goose-move-ele">
            <div class="catch-hand">
                <div class="catch-hand-line"></div>
                <div class="catch-hand-left"></div>
                <div class="catch-hand-right"></div>
                <div class="catch-hand-center"></div>
            </div>

            <div class="goose-left-leg"></div>
            <div class="goose-right-leg"></div>
            <div class="goose-body">
                <div class="goose-mouth"></div>
                <div class="goose-nose"></div>
                <div class="goose-glasses"></div>
                <div class="goose-right-hand"></div>
                <div class="goose-bag"></div>
                <div class="goose-left-hand"></div>

            </div>
        </div>
    </div>
</template>

<script>
    import {gsap} from "gsap";

    //Global
    import Global from './../scripts/Global'

    export default {
        props: {
            updateEggPoint: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                isShow: true,
                flowerPlay: false,
                currentStates: '',
                eggTarget: {
                    egg1: {x: '0', y: '1', rotate: '-40', startTime: 1.5},
                    egg2: {x: '0.2', y: '1.2', rotate: '-20', startTime: 1.7},
                    egg3: {x: '0', y: '1.2', rotate: '20', startTime: 1.9},
                    egg4: {x: '-0.2', y: '1.18', rotate: '15', startTime: 2.1},
                    egg5: {x: '-0.4', y: '1.2', rotate: '60', startTime: 2.3},
                    egg6: {x: '0.4', y: '1.2', rotate: '-60', startTime: 2.5}
                }
            }
        },
        mounted() {
            this.setAnim();
            this.playNormal();
            //this.playFlower()
        },
        methods: {
            setAnim() {
                let self = this;
                this.playTl_1 = gsap.timeline({repeat: -1, repeatDelay: 3, yoyo: true});
                this.playTl_1.to('.goose-left-hand', {rotation: -10, duration: 0.5, delay: 0.5});
                this.playTl_1.to('.goose-right-hand', {rotation: -10, duration: 0.5}, "-=0.5");
                this.playTl_1.to('.goose-right-leg', {rotation: -10, duration: 0.5}, "-=0.5");
                this.playTl_1.to('.goose-glasses', {x: 5, duration: 0.5}, "-=0.5");
                this.playTl_1.to('.goose-nose', {x: 5, duration: 0.5}, "-=0.5");
                this.playTl_1.to('.goose-mouth', {x: 5, duration: 0.5}, "-=0.5");

                this.playTl_2 = gsap.timeline({repeat: -1, repeatDelay: 3, yoyo: true});
                this.playTl_2.to('.goose-left-hand', {rotation: 10, duration: 0.5, delay: 0.5});
                this.playTl_2.to('.goose-right-hand', {rotation: 10, duration: 0.5}, "-=0.5");
                this.playTl_2.to('.goose-left-leg', {rotation: 10, duration: 0.5}, "-=0.5");
                this.playTl_2.to('.goose-glasses', {x: -5, duration: 0.5}, "-=0.5");
                this.playTl_2.to('.goose-nose', {x: -5, duration: 0.5}, "-=0.5");
                this.playTl_2.to('.goose-mouth', {x: -5, duration: 0.5}, "-=0.5");

                this.playTl_3 = gsap.timeline({repeat: 1, repeatDelay: 1, yoyo: true});
                this.playTl_3.to('.goose-left-hand', {rotation: 25, duration: 0.5});
                this.playTl_3.to('.goose-right-hand', {rotation: -40, duration: 0.5}, "-=0.5");
                this.playTl_3.to('.goose-right-leg', {rotation: 60, duration: 0.5}, "-=0.5");
                this.playTl_3.to('.goose-glasses', {y: 10, duration: 0.5}, "-=0.5");
                this.playTl_3.to('.goose-mouth', {y: 10, duration: 0.5}, "-=0.5");
                this.playTl_3.to('.goose-body', {y: 3, duration: 0.5}, "-=0.5");


                this.playTl_1.pause(0);
                this.playTl_2.pause(0);
                this.playTl_3.pause(0);
            },
            playClick() {
                let self = this;
                this.currentPlay.pause(0);
                this.$nextTick(() => {
                    self.currentPlay = self.playTl_3;
                    self.playTl_3.play(0);
                    self.playTl_3.then(() => {
                        self.playNormal();
                    })
                })
            },
            playNormal() {
                if (this.currentPlay) this.currentPlay.pause(0);
                if (Math.random() > 0.5) {
                    this.currentPlay = this.playTl_1;
                    this.playTl_1.resume(0);

                } else {
                    this.currentPlay = this.playTl_2;
                    this.playTl_2.resume(0);
                }
            },
            playCollect(cb) {
                let self = this;
                if (Global.flowerActive) {
                    this.playFlower();
                }
                this.currentPlay.pause(0);
                this.currentStates = 'play-collect';
                for (let i  in this.eggTarget) {
                    gsap.to(("#" + i), {
                        delay: this.eggTarget[i].startTime,
                        duration: 0.6,
                        x: this.eggTarget[i].x + 'rem',
                        y: this.eggTarget[i].y + 'rem',
                        rotation: this.eggTarget[i].rotate,
                        ease: "elastic.out(1,0.75)",
                        onComplete: function () {
                            let targetY = (self.$refs.animEgg.offsetTop / 110);
                            // console.log('距离顶部：', self.$refs.animEgg.offsetTop, targetY, this.updateEggPoint)
                            gsap.to(("#" + i), {
                                delay: 1,
                                duration: 0.6, // 线上
                                // duration: 6.6,
                                x: '-1.6rem',
                                // y: -(targetY + 0.36) + 'rem',     // 线上
                                y: self.updateEggPoint ? `-${targetY - 0.36}rem` : `-${targetY}rem`,
                                alpha: 0,
                                rotation: '-360',
                                onComplete: function () {
                                    if (i == 'egg6') {
                                        self.collectEnd(cb);
                                    }
                                }
                            })
                        }
                    })
                }
            },
            playFlower() {
                this.dots = [];
                this.flowerPlay = true;
                for (let i = 1; i <= 50; i++) {
                    this.createFlower(i);
                }
                gsap.set(this.dots, {
                    scale: "random(0.2, 0.8)",
                    x: "random(0,90)" + 'vh',
                    rotation: "random(0,360)",
                    alpha: "random(0.4,1)"
                });

                this.flowerAnim = gsap.to(this.dots, {
                    duration: "random(5, 10)",
                    delay: "random(0,5)",
                    x: "random(-20,80)" + 'vh',
                    y: '1000',
                    rotation: "random(0,720)",
                    alpha: "random(0,0.2)"
                })

            },
            createFlower(id) {
                let flower = document.createElement('div');
                flower.className = 'huaban'
                this.$refs.flowerBox.appendChild(flower);
                this.dots.push(flower)
            },
            collectEnd(cb) {
                cb();
                this.currentStates = 'collect-end';
                this.flowerPlay = false;
                for (let i  in this.eggTarget) {
                    gsap.to(("#" + i), {duration: 0, x: 0, y: 0, alpha: 1})
                }
                setTimeout(() => {
                    this.currentStates = '';
                    this.playNormal();
                    if (Global.flowerActive) {
                        this.flowerAnim.kill();
                        this.$refs.flowerBox.innerHTML = ''
                        Global.flowerActive = false;
                    }
                }, 1000)
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">
    //背景
    .bg-mask {position: fixed;left: 0;top: 0;width: 100vw;height: 100vh;background: rgba(0, 0, 0, .6);z-index: 20;opacity: 0;display: none;}
    .light-box {position: fixed;left: 0;top: 0;width: 100vw;height: 100vh;display: none;z-index: 21;}
    .light-1 {position: absolute;left: 0;bottom: 2rem;width: 2.81rem;height: 5.36rem;background-image: url('#{$path}/goose/light-1.png');@include singleBg;}
    .light-2 {position: absolute;left: 10%;bottom: 2rem;width: 2.16rem;height: 5.59rem;background-image: url('#{$path}/goose/light-2.png');@include singleBg;}
    .light-3 {position: absolute;right: 0;bottom: 2rem;width: 2.81rem;height: 5.36rem;background-image: url('#{$path}/goose/light-3.png');@include singleBg;}
    .light-4 {position: absolute;right: 10%;bottom: 2rem;width: 2.16rem;height: 5.59rem;background-image: url('#{$path}/goose/light-4.png');@include singleBg;}
    .goose-move-ele {width: 100%;height: 100%;position: absolute;z-index: 23;}
    //抓手
    .catch-hand {position: absolute;z-index: 21;left: 50%;width: 0.5rem;height: 0.5rem;margin-left: -0.25rem;top: -0.7rem;display: none;}
    .catch-hand-line {width: 0.07rem;height: 4rem;position: absolute;left: 50%;margin-left: -0.03rem;background-color: #FFD788;bottom: 0.25rem;}
    .catch-hand-center {position: absolute;left: 0;width: 0.5rem;height: 0.5rem;background-image: url('#{$path}/goose/catch-hand-center.png');@include singleBg;z-index: 22;}
    .catch-hand-left {position: absolute;left: -0.25rem;top: 0.2rem;width: 0.45rem;height: 0.77rem;background-image: url('#{$path}/goose/catch-hand-left.png');@include singleBg;z-index: 22;transform-origin: 0.44rem 0.1rem;}
    .catch-hand-right {position: absolute;right: -0.25rem;top: 0.2rem;width: 0.45rem;height: 0.77rem;background-image: url('#{$path}/goose/catch-hand-right.png');@include singleBg;z-index: 22;}
    //鹅
    .goose {width: 1.3rem;height: 2.42rem;}
    .goose-body {position: absolute;left: 0.06rem;width: 1.18rem;height: 2.14rem;background-image: url('#{$path}/goose/body.png');@include singleBg;z-index: 22;}
    .goose-bag {position: absolute;left: 0.01rem;top: 1.1rem;width: 1.02rem;height: 0.47rem;background-image: url('#{$path}/goose/bag.png');@include singleBg;}
    .goose-left-hand {position: absolute;left: -0.02rem;top: 1.14rem;width: 0.51rem;height: 0.8rem;background-image: url('#{$path}/goose/left-hand.png');@include singleBg;transform-origin: center top;}
    .goose-right-hand {position: absolute;right: 0rem;top: 1.14rem;width: 0.51rem;height: 0.8rem;background-image: url('#{$path}/goose/right-hand.png');@include singleBg;transform-origin: center top;}
    .goose-glasses {position: absolute;left: 0.13rem;top: 0.2rem;width: 0.9rem;height: 0.2rem;background-image: url('#{$path}/goose/glasses.png');@include singleBg;transform-origin: center top;}
    .goose-mouth {position: absolute;left: 50%;margin-left: -0.15rem;top: 0.37rem;width: 0.27rem;height: 0.27rem;background-image: url('#{$path}/goose/mouth.png');@include singleBg;}
    .goose-nose {position: absolute;left: 0.34rem;top: 0.1rem;width: 0.48rem;height: 0.54rem;background-image: url('#{$path}/goose/nose.png');@include singleBg;}
    .goose-left-leg {position: absolute;left: 0.2rem;bottom: 0;width: 0.42rem;height: 0.45rem;background-image: url('#{$path}/goose/left-leg.png');@include singleBg;z-index: 21;transform-origin: 0.38rem top;}
    .goose-right-leg {position: absolute;right: 0.2rem;bottom: 0;width: 0.42rem;height: 0.45rem;background-image: url('#{$path}/goose/right-leg.png');@include singleBg;z-index: 21;transform-origin: 0.04rem top;}
    //蛋
    .anim-eggs {
        width: 0.31rem;height: 0.4rem;position: absolute;left: 50%;margin-left: -0.15rem;bottom: 3.65rem;display: block;
        div {width: 0.31rem;height: 0.39rem;position: absolute;left: 0;top: 0;background-image: url('#{$path}/goose/egg.png');@include singleBg;}
        }
    .play-collect {
        div {backface-visibility: hidden; transform-style: preserve-3d;}
        .light-box {display: block;animation: maskShow 0.2s 1 ease-out both;}
        .light-1 {animation: flash 1s infinite linear both;}
        .light-2 {animation: flash 2s infinite linear both;}
        .light-3 {animation: flash 1.5s infinite linear both;}
        .light-4 {animation: flash 2.5s infinite linear both;}
        .bg-mask {display: block;animation: maskShow 0.2s 1 ease-out both;}
        .catch-hand {display: block;animation: catch 1s 1 ease-out both;}
        .goose-move-ele {animation: moveUp 1s 1s 1 ease-out both;}
        .goose-left-leg {animation: left-leg-shake 0.7s 1s infinite linear both;}
        .goose-right-leg {animation: right-leg-shake 0.7s 1s infinite linear both;}
        .goose-left-hand {animation: left-hand-shake 0.5s 1s infinite ease-in-out;}
        .goose-right-hand {animation: right-hand-shake 0.5s 1s infinite ease-in-out;}
        .goose-glasses {animation: glasses-drop 0.2s 1s 1 ease-in both;}
        .goose-mouth {animation: mouthDown 0.2s 1s 1 ease-out both;}
        }
    .collect-end {
        .anim-eggs {display: none;}
        .light-box {display: block;animation: maskHide 0.2s 1 ease-out both;}
        .bg-mask {display: block;animation: maskHide 0.2s 1 ease-out both;}
        .catch-hand {display: block;animation: catch-out 1s 1 ease-out both;}
        .goose-move-ele {animation: moveDown 0.3s 1 ease-out both;}
        }
    //花瓣雨
    .flower-box {position: fixed;left: 0;top: 0;width: 100vw;height: 100vh;z-index: 22;}
    .huaban {position: absolute;top: -0.6rem;width: 0.7rem;height: 0.4rem;background-image: url('#{$path}/giftEggs/huaban.png');@include singleBg;}
    //keyframes
    @keyframes catch {
        0% {transform: translateY(-4rem)}
        100% {transform: translateY(0)}
        }
    @keyframes moveUp {
        0% {transform: translateY(0);}
        100% {transform: translateY(-0.7rem);}
        }
    @keyframes moveDown {
        0% {transform: translateY(-0.7rem);}
        100% {transform: translateY(0);}
        }
    @keyframes left-leg-shake {
        0% {transform: rotate(0)}
        50% {transform: rotate(40deg)}
        100% {transform: rotate(0)}
        }
    @keyframes right-leg-shake {
        0% {transform: rotate(0)}
        50% {transform: rotate(-40deg)}
        100% {transform: rotate(0)}
        }
    @keyframes left-hand-shake {
        0% {transform: rotate(40deg)}
        50% {transform: rotate(80deg)}
        100% {transform: rotate(40deg)}
        }
    @keyframes right-hand-shake {
        0% {transform: rotate(-40deg)}
        50% {transform: rotate(-80deg)}
        100% {transform: rotate(-40deg)}
        }
    @keyframes glasses-drop {
        0% {transform: translateY(0) rotate(0) }
        100% {transform: translateY(0.15rem) rotate(15deg) }
        }
    @keyframes flash {
        0% {opacity: 0.5 }
        50% {opacity: 1 }
        100% {opacity: 0.5;}
        }
    @keyframes catch-out {
        0% {transform: translateY(0)}
        100% {transform: translateY(-4rem)}
        }
    @keyframes mouthDown {
        0% {transform: translateY(0)}
        100% {transform: translateY(0.1rem)}
        }
</style>